// config
import { appConfig } from '../../../../config/app-config';
import { UiMessageSnack } from '../model/message-snack.class';
import { UiMessageSnackType } from '../model/message-snack.types';

// message snack
export const UI_MESSAGE_SNACK = 'UI_MESSAGE_SNACK';
export const UI_MESSAGE_SNACK_RESET = 'UI_MESSAGE_SNACK_RESET';

// ------------------------------------------------------------------------------------------------
// action creators
// ------------------------------------------------------------------------------------------------

export function uiMessageSnack(
   message: string,
   module: string = 'Unknown',
   type: UiMessageSnackType = 'INFO',
   duration: number = appConfig.app.errMsgDurationToShow
) {
    const obj = new UiMessageSnack(message, module, type, duration);
    return { type: UI_MESSAGE_SNACK, payload: {object: obj} };
}

export function uiMessageSnackReset() {
   return { type: UI_MESSAGE_SNACK_RESET, payload: '' };
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/components/message-snack/store/actions.ts